export const transacStatuses = [
    {
        'name' : 'INITIAL',
        'color': 'mat-blue-500-bg'
    },
    {
        'name' : 'AUTHORISED',
        'color': 'mat-green-500-bg'
    },
    {
        'name' : 'CAPTURED',
        'color': 'mat-orange-500-bg'
    },
    {
        'name' : 'CANCELED',
        'color': 'mat-pink-500-bg'
    },
    {
        'name' : 'PREORDER_CANCELEDBYUSER',
        'color': 'mat-pink-900-bg'
    },
    {
        'name' : 'REFUNDED',
        'color': 'mat-red-500-bg'
    },
    {
        'name' : 'PAYMENT_ERROR',
        'color': 'mat-red-900-bg'
    },
    {
        'name' : 'CAPTURE_FAILED',
        'color': 'mat-red-900-bg'
    },
    {
        'name' : 'REFUSED',
        'color': 'mat-red-900-bg'
    },
    {
        'name' : 'NOT_CREATED',
        'color': 'mat-orange-900-bg'
    },
    {
        'name' : 'EXPIRED',
        'color': 'mat-orange-400-bg'
    },
];



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/transactions/transaction-statuses.ts